export default __webpack_public_path__ + "static/media/mixkit-magic-sweep-game-trophy-257.dcc56650.wav";